<template>
  <VisionFiveFilters :loading="loading" @filter="onFilter" />
  <div ref="chart" />
</template>

<script>
import VisionFiveFilters from './VisionFiveFilters.vue';
import { getVisionFiveCharts } from '../visionFiveService';
import chart from '@/modules/shared/chartMixin';

export default {
  components: { VisionFiveFilters },
  mixins: [chart],
  methods: {
    async getCharts(filters) { return await getVisionFiveCharts(filters); },
  },
};
</script>
